import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Radio } from "react-aria-components";
import {
    FicFileDrop,
    FicInput,
    FicRadio,
    FicCheckbox,
    FicTextArea,
} from "../../Utils/FormInputComponents/index";
import { useEffect } from "react";
import "../../../../../style/autoVentas/IngresosForm.css";
import GenBtn from "../../components/GenBtn";
import LoadMask from "../../Utils/LoadMask/LoadMask";
import { withRouter } from "react-router";

function VendedoresFormVer(props) {
    const { datosDelVendedor, history } = props;
    const urlParams = props.match.params;
    const vendedorId = urlParams.vendedorId;
    const empresa = urlParams.empresa;
    const [loadingState, setLoadingState] = useState(true);

    const {
        handleSubmit,
        reset,
        control,
        formState: { errors },
        watch,
    } = useForm({
        mode: "all",
        defaultValues: async () => {
            const formData = await datosDelVendedor(vendedorId);
            setLoadingState(false);
            return formData;
        },
    });

    return (
        <React.Fragment>
            <br />
            <h3
                className="p-2  title rounded shadow"
                style={{
                    background:
                        "linear-gradient(to top right, #790021, #2d2d2d)",
                }}
            >
                Agregar Vendedor
            </h3>
            <br />
            <div className="d-flex flex-row justify-content-start mb-2">
                <GenBtn
                    BtnColor="#787878"
                    style={{ width: "100px", height: "40px" }}
                    onPress={(e) => {
                        history.push(`/auto_ventas/${empresa}/vendedores`);
                    }}
                >
                    Regresar
                </GenBtn>
            </div>

            <LoadMask loading={loadingState} color="#bd0034" blur={true}>
                <form
                    encType="multipart/form-data"
                    onSubmit={handleSubmit(() => {})}
                    className="vendedores-form__form-container"
                >
                    <div className="vendedores-form__inputs-container">
                        <FicInput
                            label="Nombre"
                            name="nombre"
                            control={control}
                            isDisabled={true}
                        />
                        <FicInput
                            label="Numero de DPI"
                            name="dpi"
                            control={control}
                            isDisabled={true}
                        />
                        <FicInput
                            label="Numero de Telefono"
                            name="num_telefono"
                            control={control}
                            isDisabled={true}
                        />
                        <FicInput
                            label="Direccion"
                            name="direccion"
                            control={control}
                            isDisabled={true}
                        />
                    </div>
                </form>
            </LoadMask>
        </React.Fragment>
    );
}

export default withRouter(VendedoresFormVer);
